import djangoFetch, { objectToQueryString } from '../lib/fetch/djangoFetch';
import Choices from 'choices.js';

class DestinationAccommodationTypeCampSelector {

  constructor(elements, apiEndpoints, translations, selectedCamps=[]) {
    this.elements = elements;
    this.apiEndpoints = apiEndpoints;
    this.selectedCamps = selectedCamps;
    this.eventHandlers = {};
    this.campSelector = new Choices(this.elements.camp_selector, {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      placeholder: true,
      placeholderValue: translations.CHOOSE_CAMPING_NAME,
      noResultsText: '',
      noChoicesText: '',
      classNames: {
        containerOuter: 'choices multiple-location-choices',
      },
    });
    this.campSelector.passedElement.element.addEventListener('change', () => {
      this.selectedCamps = this.campSelector.getValue(true);
      this.hideCampsSelector();
      this.campSelector.input.focus();
    });
    this.init();
    this.update();
  }

  init() {
    this.eventHandlers['camp_selector_update'] = () => {
      this.update();
    };
    this.elements.destination_selector.addEventListener('change', this.eventHandlers['camp_selector_update']);
    this.elements.accommodation_type_selector.addEventListener('change', this.eventHandlers['camp_selector_update']);
  }

  uninit() {
    this.elements.destination_selector.removeEventListener('change', this.eventHandlers['camp_selector_update']);
    this.elements.accommodation_type_selector.removeEventListener('change', this.eventHandlers['camp_selector_update']);
    this.eventHandlers = {};
  }

  getSelectedDestination() {
    return this.elements.destination_selector.options[this.elements.destination_selector.selectedIndex].value;
  }

  getSelectedAccommodationType() {
    return this.elements.accommodation_type_selector.options[this.elements.accommodation_type_selector.selectedIndex].value;
  }

  getSelectedCamps() {
    return Array.from(this.elements.camp_selector.options).filter(option => option.selected).map(option => option.value);
  }

  update() {
    const selectedDestination = this.getSelectedDestination();
    if (selectedDestination) {
      this.campSelector.clearChoices();
      this.updateAccommodationTypeSelector(selectedDestination).then(() => {
        const selectedAccommodationType = this.getSelectedAccommodationType();
        if (selectedAccommodationType) {
          this.updateCampsSelector(selectedDestination, selectedAccommodationType);
        } else {
          this.campSelector.disable();
        }
      }).catch(error => error);
    } else {
      this.elements.accommodation_type_selector.disabled = true;
    }

    this.showCampsSelector();
  }

  _clearSelect(selectElement) {
    for (let i = selectElement.options.length - 1 ; i >= 0 ; i--) {
      selectElement.remove(i);
    }
  }

  _getOptionElement(value, label, selected=false) {
    let optionElement = document.createElement('option');
    optionElement.text = label;
    optionElement.value = value;
    if (selected) {
      optionElement.selected = true;
    }
    return optionElement;
  }

  updateAccommodationTypeSelector(destinationId) {
    const selectedAccommodationType = this.getSelectedAccommodationType();
    this.elements.accommodation_type_selector.disabled = true;
    const accommodationTypeQueryObject = {
      destination: destinationId,
    };
    return djangoFetch(`${this.apiEndpoints.accommodation_types_url}?${objectToQueryString(accommodationTypeQueryObject)}`)
      .then(response => {
        if (response.status >= 200 && response.status < 400) {
          return response.json();
        }
        return Promise.reject('Network error');
      })
      .then(json => {
        this._clearSelect(this.elements.accommodation_type_selector);
        let anyOptionElement = this._getOptionElement('ANY', json['ANY'], selectedAccommodationType === 'ANY');
        this.elements.accommodation_type_selector.add(anyOptionElement);
        Object.entries(json).filter(([value]) => value !== 'ANY').forEach(([value, label]) => {
          let optionElement = this._getOptionElement(value, label, selectedAccommodationType === value);
          this.elements.accommodation_type_selector.add(optionElement);
        });
        this.elements.accommodation_type_selector.disabled = false;
      })
      .catch(error => error);
  }

  updateCampsSelector(destinationId, accommodationType) {
    this.campSelector.disable();
    const campQueryObject = {
      destination: destinationId,
      acctype: accommodationType,
    };
    djangoFetch(`${this.apiEndpoints.camps_url}?${objectToQueryString(campQueryObject)}`)
      .then(response => {
        if (response.status >= 200 && response.status < 400) {
          return response.json();
        }
        return Promise.reject('Network error');
      })
      .then(json => {
        this.campSelector.clearStore();
        this.selectedCamps = this.selectedCamps.filter(campId => (Object.keys(json).indexOf(campId) !== -1));
        const selectorOptionsData = Object.entries(json)
          .map(([key, value]) => (
            {
              value: key,
              label: value,
              selected: (this.selectedCamps.indexOf(key) !== -1),
            }));
        this.campSelector.setChoices(selectorOptionsData, 'value', 'label', false);
        this.campSelector.enable();
        this.hideCampsSelector();
      })
      .catch(error => error);
  }

  showCampsSelector() {
    this.campSelector.input.element.classList.remove('hide-input');
  }

  hideCampsSelector() {
    this.campSelector.choiceList.element.childNodes.forEach(element => {
      if (element.className.includes('has-no-choices')) {
        this.campSelector.input.element.classList.add('hide-input');
      } else {
        this.campSelector.input.element.classList.remove('hide-input');
      }
    });
  }
}

export default DestinationAccommodationTypeCampSelector;



// WEBPACK FOOTER //
// ./src/js/forms/DestinationAccommodationTypeCampSelector.js